
export type GetAggregatedMetricsParams = {
startDate: string;
endDate: string;
};
